import { useGlobalBridge } from '@beefco/bridge/temporary';

// FIXME: should remove @beefco/bridge bindings
export var useCommandBus = function useCommandBus() {
  return useGlobalBridge().bus;
};